exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appearance-hint[data-v-974661b4] {\n  margin: 0 0 16px;\n  font-size: 13px;\n  color: #6c737f;\n}\n.appearance-field[data-v-974661b4] {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n}\n.appearance-field label[data-v-974661b4] {\n  margin: 0;\n  font-size: 12px;\n  color: #1f2a37;\n}\n", ""]);

// exports
